/* eslint-disable */
import * as THREE from 'three'
import React, { useMemo, memo } from 'react'
import { Bounds } from '../../../models/Types'

const Background: React.FC<{ bounds: Bounds }> = memo(({ bounds }) => {
  const sphereGeometry = useMemo(() => (
    <sphereGeometry args={[Math.max(bounds.max.x - bounds.min.x, bounds.max.z - bounds.min.z), 64, 64]} />
  ), [bounds]);

  const meshBasicMaterial = useMemo(() => (
    <meshBasicMaterial color="black" side={THREE.BackSide} />
  ), []);

  return (
    <>
      <mesh>
        {sphereGeometry}
        {meshBasicMaterial}
      </mesh>
    </>
  )
}, (prev, next) => prev.bounds.min.equals(next.bounds.min) && prev.bounds.max.equals(next.bounds.max))

export default Background;